jQuery( document ).ready(function($) {
    $('.simplenav_menu').on('click', () => {
      $('.simplenav_nav').toggle()
    })

    $( ".simplenav_item" ).hover(
      function() {
        $( this ).find('.simplenav_children').css('max-height', '200px');
      }, function() {
        $( this ).find('.simplenav_children').css('max-height', '0');
      }
    );
});